import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JalaliDateCalculatorService } from 'ngx-persian';
import { PaymentService } from 'src/app/feature/payment/services';
import { PaymentEntity } from 'src/app/shared';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-payment-detailed',
  templateUrl: './payment-detailed.component.html',
  styleUrls: ['./payment-detailed.component.sass'],
})
export class PaymentDetailedComponent implements OnInit {
  public payment!: PaymentEntity;
  public persianStatus!: string;

  private subsink = new SubSink();

  constructor(
    private activatedRoute: ActivatedRoute,
    private paymentService: PaymentService,
    private jalaliDateCalculator: JalaliDateCalculatorService
  ) {
    this.subsink.sink = this.activatedRoute.data.subscribe({
      next: (data) => {
        if (data['payment']) {
          this.payment = data['payment'];

          this.persianStatus = this.paymentService.getPersianStatusForPayment(
            this.payment.status
          );
        }
      },
    });
  }

  ngOnInit(): void {}
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  /**
   * To jalali date.
   * @param date {Date}
   * @returns
   */

  public toJalaliDate(date?: Date) {
    if (!date) return 'نامشخص';
    const jDate = this.jalaliDateCalculator.convertToJalali(new Date(date));
    return `${jDate.year}/${jDate.month}/${jDate.day}`;
  }

  public getPersianStatus() {}
}
